import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { TranslatorContext } from "../context/Translator";
import { SidebarContext } from "../context/Sidebar";
import sidenavs from "../assets/data/sidenavs.json";
import { logout } from "../APIs/AdminRequests";

export default function SidebarLayout() {
    
    const { t, n, currentLanguage } = useContext(TranslatorContext);
    const { sidebar } = useContext(SidebarContext);

     const logoutFunction = () => {
            logout().then
            ((res) => {
                localStorage.removeItem('authToken');
                window.location.href = '/login';
            })
        }
    const handleDropdown = (event) => {
        const buttonElement = event.currentTarget;
        const itemElement = buttonElement.parentElement;
        const isActive = itemElement.classList.contains('active');
        const allItems = document.querySelectorAll('.mc-sidebar-menu-item');
        const allDropdowns = document.querySelectorAll('.mc-sidebar-dropdown-list');
        const dropdownElement = itemElement.querySelector('.mc-sidebar-dropdown-list');

        if (isActive) {
            itemElement.classList.remove('active');
            dropdownElement.style.height = "0px";
        }
        else {
            allItems.forEach(item => item.classList.remove('active'));
            allDropdowns.forEach(dropdown => dropdown.style.height = "0px");
            
            itemElement.classList.add('active');
            dropdownElement.style.height = dropdownElement.scrollHeight + "px";
        }
    }

    const menuItem = (menu,menuIndex) => {
        return(
            <li key={menuIndex} className='mc-sidebar-menu-item'>
                {menu.submenus ?
                    <>
                        <button type="button" className="mc-sidebar-menu-btn" onClick={handleDropdown}>
                            <i className="material-icons">{ menu.icon }</i>
                            <span>{t(menu.text)}</span>
                            { menu.badge?.text && <sup className={ menu.badge.variant }>{t(menu.badge.text)}</sup> }
                            { menu.badge?.count && <sup className={ menu.badge.variant }>{n(menu.badge.count)}</sup> }
                            { currentLanguage?.dir === "ltr" ? 
                                <small className="material-icons right">chevron_right</small> 
                                : <small className="material-icons left">chevron_left</small>
                            }
                        </button>

                        <ul className='mc-sidebar-dropdown-list'>
                            {menu.submenus.map((submenu, submenusIndex) => (
                                <li key={submenusIndex} className="mc-sidebar-dropdown-item">
                                    <Link to={submenu.path} className="mc-sidebar-dropdown-link">{t(submenu.text)}</Link>
                                </li>
                            ))}
                        </ul>
                    </>
                :
                    <Link to={menu.path} className="mc-sidebar-menu-btn">
                        <i className="material-icons">{ menu.icon }</i>
                        <span>{t(menu.text)}</span>
                        { menu.badge?.count && <sup className={ menu.badge.variant }>{n(menu.badge.count)}</sup> }
                        { menu.badge?.text && <sup className={ menu.badge.variant }>{t(menu.badge.text)}</sup> }
                    </Link>
                }
            </li>
           );
    }

    const menuPermissions = {
        'admins': 'list admin',
        'customers': 'list customer', 
        'sims': 'list sim dashboard',
        'roles': 'list role',
        'settings': 'list admin',
        'Countries/Cities/States': 'list countries',
        'user_types': 'list user type',
        'users_management': 'list user',
        'organization_chart': 'view organization structure'
    };

    const alwaysVisible = [];

    const hasPermission = (requiredPermission) => {
        const permissions = localStorage.getItem('permissions');
        if (!permissions) return false;
        
        const permissionList = permissions.split(',').map(item => item.trim());
        return permissionList.includes(requiredPermission);
    };

    const shouldShowMenu = (menuText) => {
        if (alwaysVisible.includes(menuText)) {
            return true;
        }

        const requiredPermission = menuPermissions[menuText];
        if (!requiredPermission) {
            return false; 
        }

        return hasPermission(requiredPermission);
    };
    return (
        <aside as="aside" className={`mc-sidebar thin-scrolling ${ sidebar && "active"}`}>
            {sidenavs?.map((sidenav, sidenavIndex) => (
                <menu key={sidenavIndex}  className="mc-sidebar-menu">
                    <h5 className="mc-sidebar-menu-title">{t(sidenav.title)}</h5>
                    <ul className="mc-sidebar-menu-list">
                        {sidenav.menus.map((menu, menuIndex) => {
                            if (shouldShowMenu(menu.text)) {
                                return menuItem(menu, menuIndex);
                            }
                            return null;
                        })}
                    </ul>
                </menu>
            ))}

            <div className="mc-sidebar-logout text-center" onClick={() => logoutFunction()}>
                <Link to='/login' className="mc-btn primary sm">
                    <i className="material-icons">lock</i>
                    <span>{t('logout')}</span>
                </Link>
            </div>
        </aside>
    )
}